/* Extend Enterprise facets with genuine variant cards, without changing collection rules. */
(() => {
  const definitions = [
    ['filter.v.m.custom.groesse', 'Größe (BxLxH)'],
    ['filter.v.m.custom.farbe', 'Farbe'],
    ['filter.v.m.custom.stoffart', 'Stoffart'],
    ['filter.v.m.custom.form', 'Form'],
    ['filter.v.m.custom.fuellart', 'Füllart'],
    ['filter.p.m.custom.einsatzort', 'Verwendung'],
    ['filter.v.m.custom.einsatzort', 'Einsatzort'],
    ['filter.v.m.custom.design', 'Design'],
    ['filter.v.availability', 'Verfügbarkeit']
  ];
  const keys = new Set(definitions.map(([key]) => key));
  const number = (value) => Number(String(value).replace(',', '.'));
  function values(record, key) {
    if (key === 'filter.v.availability') return [record.available ? '1' : '0'];
    const value = record.values[key];
    return (Array.isArray(value) ? value : [value]).filter((x) => x != null && x !== '').map(String);
  }
  function matches(record, params, ignore = '') {
    for (const key of new Set(params.keys())) {
      if (!key.startsWith('filter.') || key === ignore) continue;
      const selected = params.getAll(key).filter(Boolean);
      if (!selected.length) continue;
      if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
        const bound = number(selected[0]);
        if (!Number.isFinite(bound)) return false;
        if (key.endsWith('gte') && record.price / 100 < bound) return false;
        if (key.endsWith('lte') && record.price / 100 > bound) return false;
      } else if (!keys.has(key) || !selected.some((x) => values(record, key).includes(x))) {
        return false;
      }
    }
    return true;
  }
  function group(parent, key, title) {
    let detail = Array.from(parent.querySelectorAll('.filter')).find((x) => x.id === `filter-${key}`);
    if (detail) return detail;
    const wrapper = document.createElement('details-disclosure');
    detail = document.createElement('details');
    detail.id = `filter-${key}`;
    detail.className = 'filter disclosure';
    detail.dataset.type = 'list';
    detail.open = true;
    detail.dataset.betiesGroup = 'true';
    const summary = document.createElement('summary');
    summary.className = 'filter__toggle';
    const heading = document.createElement('span');
    heading.className = 'font-bold';
    heading.textContent = title;
    summary.append(heading);
    const panel = document.createElement('div');
    panel.className = 'disclosure__panel has-motion';
    panel.innerHTML = '<div class="disclosure__content"><div class="filter__content"><ul role="list"></ul></div></div>';
    detail.append(summary, panel);
    wrapper.append(detail);
    parent.append(wrapper);
    return detail;
  }
  function option(detail, key, value, label) {
    let input = Array.from(detail.querySelectorAll('input[type="checkbox"]')).find((x) => x.name === key && x.value === value);
    if (input) return input;
    const list = detail.querySelector('ul');
    if (!list) return null;
    const li = document.createElement('li');
    input = document.createElement('input');
    input.type = 'checkbox';
    input.name = key;
    input.value = value;
    input.id = `beties-${key}-${encodeURIComponent(value)}`;
    input.className = 'checkbox visually-hidden focus-label-before';
    input.dataset.betiesNativeCount = '0';
    const text = document.createElement('label');
    text.htmlFor = input.id;
    text.className = 'filter__label flex items-start w-full m-0';
    const name = document.createElement('span');
    name.className = 'flex-auto';
    name.textContent = label;
    const count = document.createElement('span');
    count.className = 'filter__count';
    text.append(name, count);
    li.append(input, text);
    list.append(li);
    return input;
  }
  function sortSizeOptions(detail) {
    const lists = new Map();
    for (const input of detail.querySelectorAll('input[type="checkbox"]')) {
      if (input.name !== 'filter.v.m.custom.groesse') continue;
      const item = input.closest('li');
      if (!item) continue;
      const list = item.parentElement;
      if (!lists.has(list)) lists.set(list, []);
      lists.get(list).push({item, value: input.value});
    }
    const dimensions = (value) => (String(value).match(/\d+(?:[.,]\d+)?/g) || []).map(number);
    const compare = (a, b) => {
      const left = dimensions(a.value), right = dimensions(b.value);
      for (let i = 0; i < Math.max(left.length, right.length); i += 1) {
        const x = left[i] ?? Infinity, y = right[i] ?? Infinity;
        if (x !== y) return x - y;
      }
      return a.value.localeCompare(b.value, 'de', {numeric: true});
    };
    for (const [list, items] of lists) {
      items.sort(compare).forEach(({item}) => list.append(item));
    }
  }
  function activeFilters(form, params) {
    const area = form.querySelector('.facets__active-filters');
    const list = form.querySelector('.active-filters');
    if (!area || !list) return;
    list.querySelectorAll('[data-beties-active]').forEach((x) => x.remove());
    for (const [key, value] of params) {
      if (!keys.has(key)) continue;
      const present = Array.from(list.querySelectorAll('a')).some((a) => {
        const next = new URL(a.href).searchParams;
        return params.getAll(key).length > next.getAll(key).length && !next.getAll(key).includes(value);
      });
      if (present) continue;
      const link = document.createElement('a');
      link.className = 'active-filter flex items-center text-current';
      link.dataset.betiesActive = 'true';
      const url = new URL(window.location.href);
      const retained = url.searchParams.getAll(key).filter((x) => x !== value);
      url.searchParams.delete(key);
      retained.forEach((x) => url.searchParams.append(key, x));
      url.searchParams.delete('page');
      link.href = url.href;
      link.textContent = `${value === '1' && key.endsWith('availability') ? 'Verfügbar' : value === '0' && key.endsWith('availability') ? 'Nicht verfügbar' : value} ×`;
      list.append(link);
    }
    area.hidden = !Array.from(params.keys()).some((key) => key.startsWith('filter.'));
  }
  function prices(parent, records) {
    if (!records.length) return;
    const maximum = Math.max(...records.map((x) => x.price / 100));
    let minimumInput = parent.querySelector('[name="filter.v.price.gte"]');
    let maximumInput = parent.querySelector('[name="filter.v.price.lte"]');
    if (!minimumInput || !maximumInput) {
      const detail = group(parent, 'filter.v.price', 'Preis');
      const content = detail.querySelector('.filter__content');
      content.replaceChildren();
      detail.dataset.type = 'price_range';
      detail.querySelector('summary').innerHTML = '<div class="flex justify-between items-center"><span class="flex-auto font-bold">Preis</span><span class="disclosure__toggle"><svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" class="icon"><path d="M20 8.5 12.5 16 5 8.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></span></div>';
      // Reuse Enterprise styling even when Shopify supplies no native price facet.
      const script = document.querySelector('script[src*="/beties-variant-filters.js"]');
      if (script && !document.querySelector('link[href*="/price-range.css"]')) {
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = script.src.replace(/beties-variant-filters\.js(?=\?|$)/, 'price-range.css');
        document.head.append(stylesheet);
      }
      const range = document.createElement('div');
      range.className = 'price-range block';
      range.dataset.betiesPriceRange = 'true';
      range.innerHTML = '<div class="flex items-center">' +
        '<div class="price-range__input-wrapper flex items-center flex-auto relative"><label class="visually-hidden" for="price-range-beties-gte">Preis von</label><span class="price-range__currency">€</span><input type="number" class="input w-full" id="price-range-beties-gte" name="filter.v.price.gte" placeholder="0" min="0" step="0.01"></div>' +
        '<span class="price-range__input-separator">-</span>' +
        '<div class="price-range__input-wrapper flex items-center flex-auto relative"><label class="visually-hidden" for="price-range-beties-lte">Preis bis</label><span class="price-range__currency">€</span><input type="number" class="input w-full" id="price-range-beties-lte" name="filter.v.price.lte" min="0" step="0.01"></div></div>' +
        '<div class="price-range__sliders relative no-js-hidden"><label class="visually-hidden" for="price-range-beties-slider-min">Mindestpreis</label><input type="range" class="price-range__slider-input m-0" id="price-range-beties-slider-min" min="0" step="0.01" tabindex="0"><label class="visually-hidden" for="price-range-beties-slider-max">Höchstpreis</label><input type="range" class="price-range__slider-input m-0" id="price-range-beties-slider-max" min="0" step="0.01" tabindex="0"></div>';
      content.append(range);
      const low = range.querySelector('[name="filter.v.price.gte"]');
      const high = range.querySelector('[name="filter.v.price.lte"]');
      const lowSlider = range.querySelector('[id$="slider-min"]');
      const highSlider = range.querySelector('[id$="slider-max"]');
      const update = (event) => {
        if (event.target === lowSlider || event.target === highSlider) {
          if (number(lowSlider.value) > number(highSlider.value)) {
            event.target.value = event.target === lowSlider ? highSlider.value : lowSlider.value;
          }
          low.value = number(lowSlider.value) === 0 ? '' : lowSlider.value;
          high.value = number(highSlider.value) === number(highSlider.max) ? '' : highSlider.value;
        } else {
          lowSlider.value = low.value || '0';
          highSlider.value = high.value || highSlider.max;
        }
      };
      range.addEventListener('input', update);
      range.addEventListener('change', update);
      minimumInput = content.querySelector('[name="filter.v.price.gte"]');
      maximumInput = content.querySelector('[name="filter.v.price.lte"]');
    }
    for (const input of [minimumInput, maximumInput]) {
      input.max = String(Math.max(number(input.max || 0), maximum));
    }
    if (!maximumInput.value) maximumInput.placeholder = maximum.toFixed(2);
    const addedRange = maximumInput.closest('[data-beties-price-range]');
    if (addedRange) {
      const params = new URL(window.location.href).searchParams;
      const ceiling = Math.ceil(number(maximumInput.max));
      for (const [suffix, ending] of [['gte', 'min'], ['lte', 'max']]) {
        const input = addedRange.querySelector(`[name="filter.v.price.${suffix}"]`);
        input.value = params.get(input.name) || '';
        const slider = addedRange.querySelector(`[id$="slider-${ending}"]`);
        slider.max = String(ceiling);
        slider.value = input.value || (ending === 'min' ? '0' : String(ceiling));
      }
      maximumInput.placeholder = String(ceiling);
    }
    const component = maximumInput.closest('price-range');
    if (component) {
      const ceiling = Math.ceil(number(maximumInput.max));
      component.maxValue = ceiling;
      component.querySelectorAll('input[type="range"]').forEach((slider) => {
        slider.max = String(ceiling);
        if (slider.id.endsWith('max') && !new URL(window.location.href).searchParams.has('filter.v.price.lte')) slider.value = String(ceiling);
      });
    }
  }
  let observer;
  function sync() {
    const results = document.getElementById('filter-results');
    if (!results) return;
    observer?.disconnect();
    const entries = [];
    const seen = new Set();
    for (const card of results.querySelectorAll('[data-beties-filter-record]')) {
      try {
        const record = JSON.parse(card.dataset.betiesFilterRecord);
        if (seen.has(String(record.id))) { card.hidden = true; continue; }
        seen.add(String(record.id));
        entries.push({card, record});
      } catch { card.hidden = true; }
    }
    if (!entries.length) { observer?.observe(results, {childList:true, subtree:true}); return; }
    const params = new URL(window.location.href).searchParams;
    const page = Number(results.dataset.betiesPage || params.get('page') || 1);
    for (const {card, record} of entries) card.hidden = page > 1 || !matches(record, params);
    const form = document.getElementById('facets');
    const parent = form?.querySelector('.facets__filters');
    if (parent) {
      for (const [key, title] of definitions) {
        const options = new Set(entries.flatMap(({record}) => values(record, key)));
        for (const selected of params.getAll(key)) options.add(selected);
        if (!options.size) continue;
        const detail = group(parent, key, title);
        for (const value of options) {
          const label = key.endsWith('availability') ? (value === '1' ? 'Verfügbar' : 'Nicht verfügbar') : value;
          option(detail, key, value, label);
        }
        if (key === 'filter.v.m.custom.groesse') sortSizeOptions(detail);
        for (const input of detail.querySelectorAll('input[type="checkbox"]')) {
          if (input.name !== key) continue;
          const label = input.nextElementSibling;
          const badge = label?.querySelector('.filter__count');
          if (input.dataset.betiesNativeCount === undefined) {
            input.dataset.betiesNativeCount = badge?.textContent.match(/\d+/)?.[0] || (input.disabled ? '0' : '1');
            input.dataset.betiesNativeDisabled = input.disabled ? '1' : '0';
          }
          const extra = entries.filter(({record}) => matches(record, params, key) && values(record, key).includes(input.value)).length;
          const count = Number(input.dataset.betiesNativeCount) + extra;
          input.checked = params.getAll(key).includes(input.value);
          input.disabled = count === 0 && !input.checked;
          if (badge) badge.textContent = `(${count})`;
          if (extra || input.checked) input.closest('li')?.classList.remove('js-hidden');
        }
      }
      prices(parent, entries.map((x) => x.record));
      for (const suffix of ['gte', 'lte']) {
        const input = form.querySelector(`[name="filter.v.price.${suffix}"]`);
        if (input && params.has(input.name)) input.value = params.get(input.name);
      }
      activeFilters(form, params);
    }
    const matched = entries.filter(({record}) => matches(record, params)).length;
    let status = results.querySelector('[data-beties-filter-status]');
    if (!status) { status = document.createElement('p'); status.dataset.betiesFilterStatus = 'true'; status.className = 'text-sm mb-4'; status.setAttribute('role','status'); results.prepend(status); }
    status.textContent = `${matched} passende ${matched === 1 ? 'Kachel' : 'Kacheln'}${page > 1 ? ' auf Seite 1' : ''}`;
    observer?.observe(results, {childList:true, subtree:true});
  }
  function init() {
    if (!document.querySelector('[data-beties-filter-record]')) return;
    observer = new MutationObserver(() => sync());
    sync();
    document.addEventListener('on:facet-filters:updated', sync);
    window.addEventListener('popstate', () => setTimeout(sync, 0));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
